import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PromoBanner from '../Common/PromoBanner';
import HomeHero from './HomeHero';
import RightChecks from './RightChecks';
import YouTube from '../Common/YouTube';
import PhoneNumBanner from './PhoneNumBanner';
import SmoothRunningBusinessSupplies from './SmoothRunningBusinessSupplies';
import dots_left from '../../../assets/images/IM/Homepage/il-dots-left.svg';
import dots_right from '../../../assets/images/IM/Homepage/il-dots-right.svg';
import { getImageSrc } from '../Util/CommonUtils';
import HostedSignIn from '../Header/HostedSignIn';

const HomePage = (props) => {
  const [showSignInModal, setShowSignInModal] = useState(false);
  const mainReducer = useSelector((state) => state.mainReducer);
  const login = mainReducer.pageData.login;

  const signInClicked = () => {
    if (login) {
      props.history.push('/orderhistory');
    } else {
      setShowSignInModal(true);
    }
  };

  useEffect(() => {
    if (props.signInModal) {
      signInClicked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signInModal]);

  return (
    <div className="home-pg-container">
      <div className="container-center-lg">
        <div className="margin-main-section home-pg-banner-wrap">
          <img src={getImageSrc(dots_left)} alt="Dots left" className="home-dots dots-left" />
          <img src={getImageSrc(dots_right)} alt="Dots right" className="home-dots dots-right" />
          <PromoBanner page="HOME" />
        </div>
      </div>
      <div>
        <HomeHero {...props.pageData.Hero} signInClicked={signInClicked} />
        <RightChecks {...props.pageData.RightChecks} />
        <PhoneNumBanner />
        {props.pageData.shouldDisplayYouTubeSection && props.pageData.YouTubeSection && (
          <div className="container-center-lg">
            <div className="margin-main-section">
              <YouTube vedio={props.pageData.YouTubeSection} />
            </div>
          </div>
        )}
        <SmoothRunningBusinessSupplies {...props.pageData.SmoothRunningBusinessSupplies} />
      </div>
      {showSignInModal && (
        <HostedSignIn
          {...props}
          showModal={showSignInModal}
          closeModal={() => setShowSignInModal(false)}
          location="orderhistory"
        />
      )}
    </div>
  );
};

HomePage.propTypes = {
  pageData: PropTypes.object,
};

export default HomePage;
